export default "__VITE_ASSET__Bac_NusH__"